import { motion } from "framer-motion";
import { Menu, Leaf } from "lucide-react";
import { useState, useEffect } from "react";

const links = [
  { href: "#comunidad", label: "La comunidad" },
  { href: "#preventa", label: "Preventa" },
  { href: "#mapa", label: "Mapa" },
  { href: "#lotes", label: "Lotes" },
  { href: "#amenidades", label: "Amenidades" },
  { href: "#contacto", label: "Contacto" },
];

export default function Header({ content = {} }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-[#0B1A0F]/80 backdrop-blur-xl border-b border-[#B8E07A]/15"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5 group">
          <span className="relative w-10 h-10 rounded-full bg-gradient-to-br from-[#B8E07A] via-[#F1C36B] to-[#2C5135] flex items-center justify-center shadow-[0_0_25px_rgba(184,224,122,0.6)]">
            <Leaf className="w-5 h-5 text-[#0B1A0F]" strokeWidth={2.4} />
          </span>
          <div className="flex flex-col leading-tight">
            <span className="font-serif text-xl tracking-tight text-[#F2EFE6]">
              {content.brand_name || "Pextlán"}
            </span>
            <span className="font-fairy text-sm text-[#F1C36B] -mt-1">
              {content.brand_subtitle || "ecocomunidad"}
            </span>
          </div>
        </a>
        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-sm font-medium text-[#F2EFE6]/80 hover:text-[#F1C36B] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-[2px] w-0 bg-gradient-to-r from-[#F1C36B] to-[#B8E07A] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>
        <a
          href="#contacto"
          data-testid="header-cta"
          className="hidden md:inline-flex items-center rounded-full bg-gradient-to-r from-[#B8E07A] to-[#F1C36B] text-[#0B1A0F] px-5 py-2.5 text-sm font-semibold btn-lift"
        >
          {content.header_cta_label || "Apartar lote"}
        </a>
        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 rounded-full border border-[#B8E07A]/30 text-[#F2EFE6]"
          aria-label="Abrir menú"
          data-testid="mobile-menu-btn"
        >
          <Menu className="w-5 h-5" />
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#B8E07A]/15 bg-[#0B1A0F]/95 backdrop-blur-xl">
          <div className="flex flex-col px-6 py-4 gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-${l.href.replace("#", "")}`}
                onClick={() => setOpen(false)}
                className="py-2 text-[#F2EFE6] font-medium border-b border-[#B8E07A]/10"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contacto"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex justify-center rounded-full bg-gradient-to-r from-[#B8E07A] to-[#F1C36B] text-[#0B1A0F] px-5 py-3 text-sm font-semibold"
              data-testid="mobile-cta"
            >
              {content.header_cta_label || "Apartar lote"}
            </a>
          </div>
        </div>
      )}
    </motion.header>
  );
}
